import { createGlobalStyle } from "styled-components";
import { color } from "../resources";

const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: 'AnuphanRegular';
        src: url("../assets/fonts/OTF/Anuphan-Regular.otf") format("truetype");
    }
    @font-face {
        font-family: 'AnuphanBold';
        src: url("../assets/fonts/OTF/Anuphan-Bold.otf") format("truetype");
        font-weight: bold;
    }
    @font-face {
        font-family: 'AnuphanLight';
        src: url("../assets/fonts/OTF/Anuphan-Light.otf") format("truetype");
        font-weight: 100;
    }
    @font-face {
        font-family: 'AnuphanMedium';
        src: url("../assets/fonts/OTF/Anuphan-Medium.otf") format("truetype");
        font-weight: 600;
    }
    html, body {
        height: 100%;
        width: 100%;
        padding: 0;
        margin: 0;
        background: #FAFAFA;
        font-family: AnuphanLight, 'sans-serif' !important;
        color: #444;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .ant-menu.ant-menu-dark, .ant-menu-dark, .ant-menu.ant-menu-dark  {
        background: ${color.white} !important;
    }
    .ant-layout-sider {
        background: ${color.white} !important;
    }
    .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
        background-color: ${color.overlay} !important;
    }
    .ant-layout-sider-trigger {
        background: ${color.header} !important;
    }
    .ant-menu-dark .ant-menu-item-selected .ant-menu-item-icon, .ant-menu-dark .ant-menu-item-selected .anticon {
        color: ${color.main};
    }
    .ant-menu-item .ant-menu-item-icon + span, .ant-menu-submenu-title .ant-menu-item-icon + span, .ant-menu-item .anticon + span, .ant-menu-submenu-title .anticon + span {
        font-family: AnuphanMedium, 'sans-serif' !important;
    }
    .ant-picker{
        width: 100%
    }
    .ant-image {
        display: flex;
        margin-right: 20px
    }
    .gletcb {
        z-index: 2
    }
    .ant-table-tbody > tr > td, .ant-table-thead > tr > th {
        margin: 0;
        text-align: center;
        font-size: 13px;
    }
    tr:nth-child(odd) {
        background: #fafafa;
    }
    tr:nth-child(even) {
      background: white;
    }
    thead[class*="ant-table-thead"] th {
      background-color: #00599d !important;
      color: white;
      font-size: 13px;
    }
    .table_btn {
      margin: 0 !important;
    }
    .ant-btn {
      margin: 0;
    }
    .ant-table-tbody > tr:hover > td {
      background-color: #e0e0e0 !important;
    }
    .ant-upload-list,
    .ant-upload-list-text {
      display: flex;
    }
    .color-error {
      color: red;
    }
    .select-wrap-option .ant-select-item-option-content {
      white-space: normal;
      word-break: break-word;
    }
`;

export default GlobalStyle;
